import React from 'react';

function Services() {
  return (
    <div className="bg-blue-900 text-white min-h-screen p-6" id="services">
      <h2 className="text-3xl font-bold mb-6">Servicios y Experiencia</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-blue-800 p-4 rounded-lg shadow-lg hover:bg-blue-700 transition-colors duration-300">
          <h3 className="text-xl font-semibold">Reparación y Mantenimiento de Computadoras</h3>
          <p className="mt-2">Soluciones completas para hardware y software.</p>
        </div>
        <div className="bg-blue-800 p-4 rounded-lg shadow-lg hover:bg-blue-700 transition-colors duration-300">
          <h3 className="text-xl font-semibold">Instalación de Sistemas</h3>
          <p className="mt-2">Sistemas operativos, antivirus, Office y juegos.</p>
        </div>
        <div className="bg-blue-800 p-4 rounded-lg shadow-lg hover:bg-blue-700 transition-colors duration-300">
          <h3 className="text-xl font-semibold">Cableado de Red</h3>
          <p className="mt-2">Instalación profesional con UTP y RJ45.</p>
        </div>
        <div className="bg-blue-800 p-4 rounded-lg shadow-lg hover:bg-blue-700 transition-colors duration-300">
          <h3 className="text-xl font-semibold">Cámaras de Seguridad</h3>
          <p className="mt-2">Instalación y configuración avanzada.</p>
        </div>
        <div className="bg-blue-800 p-4 rounded-lg shadow-lg hover:bg-blue-700 transition-colors duration-300">
          <h3 className="text-xl font-semibold">Desarrollo</h3>
          <p className="mt-2">Sitios web y aplicaciones Android a medida.</p>
        </div>
      </div>
      <div className="mt-8">
        <h3 className="text-xl font-semibold mb-2">Experiencia Laboral y Proyectos</h3>
        <ul className="list-disc list-inside">
          <li>Sistema de Información para la Alcaldía de San Vicente (2020-2021)</li>
          <li>Sistema de Compra y Venta de Productos Lácteos Larreynaga (2019)</li>
          <li>Micro-empresa FLAVINO - Vinos Artesanales (2020)</li>
          <li>Aplicación Android "Phrasal Verb Guess The Way You Learn" (en proceso)</li>
        </ul>
      </div>
    </div>
  );
}

export default Services;